import { gql } from '@graphql/__generated__';

export const GET_VISIBILITY_TRANSACTIONS = gql(/* GraphQL */ `
  query GetVisibilityTransactions(
    $id: uuid!
    $startDate: timestamptz!
    $endDate: timestamptz!
  ) {
    teams(order_by: { name: asc }) {
      id
      name
    }
    property_transactions(
      limit: 10000
      where: { seller_broker_team_id: { _eq: $id } }
      order_by: { signature_date: desc }
    ) {
      id
      signature_date
      is_published
      property {
        ...PropertyCell_property
        number_of_rooms
        number_of_bedrooms
        living_surface
        property_type {
          label
        }
      }
      seller_broker_team {
        id
        name
      }
      seller_broker {
        id
        full_name
      }
      reviews(where: { completed: { _eq: true } }) {
        id
        is_buyer
      }
    }
    teams_by_pk(id: $id) {
      id
      created_at
      name
      cover_photo {
        id
        url
      }
      logo {
        id
        url
      }
      teams_users {
        created_at
        is_leader
        title
        deactivated
        order_nr
        user {
          ...UserInfo_user
          id
          full_name
          last_2_years_property_transactions_aggregate: property_transactions_aggregate(
            where: {
              signature_date: { _gte: $startDate, _lte: $endDate }
              _not: { lot: { offer_type: { _eq: "rent" } } }
              is_published: { _eq: true }
            }
          ) {
            aggregate {
              count
            }
          }
          property_transactions_aggregate(
            where: {
              _not: { lot: { offer_type: { _eq: "rent" } } }
              is_published: { _eq: true }
            }
          ) {
            aggregate {
              count
            }
          }
        }
      }
    }
    team_transactions: property_transactions_aggregate(
      where: {
        seller_broker_team_id: { _eq: $id }
        signature_date: { _gte: $startDate, _lte: $endDate }
        _not: { lot: { offer_type: { _eq: "rent" } } }
        is_published: { _eq: true }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`);
